/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_A_End_HeaderInputs */



/**
* | output |
* | --- |
* | "Group A End" |
*
* @param {Compare_Event_Groups_Csv_Group_A_End_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_a_end_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_A_End_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_A_End_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin du groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe A Ende")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fine del Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа А Конец")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo A Final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("A组结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループA終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह ए का अंत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fim do Grupo A")
	return /** @type {LocalizedString} */ ("Group A End")
});